/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import { Routes, Route } from "react-router-dom"; // Import Routes and Route
import "./App.scss";
// Removed: LiveAPIProvider, SidePanel, Altair, ControlTray, cn, videoRef, videoStream, setVideoStream
// These are now part of MainAppLayout.tsx

import OcodyHomepage from './components/ocody-homepage/OcodyHomepage';
import PaymentPage from './pages/PaymentPage';
import SignInPage from './pages/SignInPage'; // Import SignInPage
import SignUpPage from './pages/SignUpPage'; // Import SignUpPage
import MainAppLayout from './layouts/MainAppLayout'; // Import MainAppLayout
import { LiveClientOptions } from "./types";

import formbricks from "@formbricks/js";


if (typeof window !== "undefined") {
  formbricks.setup({
    environmentId: "cmbhb28id50nkve019w8fd6ne", 
    appUrl: "https://app.formbricks.com",
  });
}

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
}

const apiOptions: LiveClientOptions = {
  apiKey: API_KEY,
};

function App() {
  // Removed: showHomepage, setShowHomepage, handleStartCoding state and logic

  return (
    <Routes>
      <Route path="/" element={<OcodyHomepage />} />
      <Route path="/app" element={<MainAppLayout apiOptions={apiOptions} />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      {/* Add a catch-all route for 404 */}
      <Route path="*" element={
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>404 - Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
        </div>
      } />
    </Routes>
  );
}

export default App;
